import { deleteInitiativesUnlinkJira } from '@api';
import { initiativesJiraIssueRemoveSyncSlice } from '../@sync/remove';
import { AMPLITUDE_EVENT, createLogSaga } from '@sonar-software/sonar-analytics';
import { createDeleteAsyncSlice, SagaYieldType } from '@sonar-software/xuder';

export const deleteJiraInitiativesUnlinkIssueSlice = createDeleteAsyncSlice({
	additionalRequestSteps: [
		{
			actionHandler: createLogSaga(AMPLITUDE_EVENT.JIRA_ISSUE_UNLINKED, (action) => action.data),
			type: SagaYieldType.Every
		}
	],
	httpSagaOptions: {
		successCombinationActionCreators: [
			(request) => initiativesJiraIssueRemoveSyncSlice.syncActionCreator({
				customerId: request.customerId,
				initiativeId: request.initiativeId,
				issueKey: request.issueKey
			})
		]
	},
	name: 'jiraInitiativesUnlinkIssue',
	receive: false,
	request: true,
	requestHandler: deleteInitiativesUnlinkJira
});
